var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"wish-info",attrs:{"to":{name: 'ViewWish', params: {id: _vm.wish.id}}}},[_c('div',[_vm._v(" "+_vm._s(_vm.wish.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }